/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DossieContratoDocumentosAliases {
  DATA_DOCUMENTO_RESPONSIVO = 'data-documento-responsivo',
  DECK_DOSSIE = 'deck-dossie',
  DECK_RESPONSIVO = 'deck-responsivo',
  FETCH_DOSSIE_CONTRATO_DOCUMENTOS = 'fetch-dossie-contrato-documentos',
  FIELD_DATA_DOCUMENTO = 'field-data-documento',
  FIELD_IMAGE = 'field-image',
  FIELD_IMAGE_RESPONSIVO = 'field-image-responsivo',
  FIELD_OBSERVACAO = 'field-observacao',
  FIELD_OBSERVACAO_RESPONSIVO = 'field-observacao-responsivo',
  FIELD_TIPO_DOCUMENTO = 'field-tipo-documento',
  FIELD_TIPO_DOCUMENTO_RESPONSIVOS = 'field-tipo-documento-responsivos',
  HPMS_DOCUMENTOS = 'hpms-documentos',
  HPMS_DOCUMENTOS_RESPONSIVO = 'hpms-documentos-responsivo',
  IMAGE_DOWNLOAD = 'image-download',
  IMAGE_DOWNLOAD_RESPONSIVO = 'image-download-responsivo',
  MEDIA_QUERY = 'media-query',
  MEDIA_QUERY_REPONSIVO = 'media-query-reponsivo',
  PANEL_DOCUMENTOS = 'panel-documentos',
  TEXT_DATA_DOCUMENTO = 'text-data-documento',
  TEXT_DATA_DOCUMENTOS_RESPONSIVO = 'text-data-documentos-responsivo',
  TEXT_OBSERVACAO = 'text-observacao',
  TEXT_OBSERVACAO_RESPONSIVO = 'text-observacao-responsivo',
  TEXT_TIPO_DOCUMENTO = 'text-tipo-documento',
  TEXT_TIPO_DOCUMENTO_RESPONSIVOS = 'text-tipo-documento-responsivos',
}
export { DossieContratoDocumentosAliases };
